module.exports = __webpack_public_path__ + "static/006733-098dbb4b18141b78f24d9f6007586c30.jpg";